import { Grid, IconButton } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';

import agencySupport from 'core/assets/svg/agency-support.svg';
import chatBubble from 'core/assets/svg/chat-bubble.svg';
import phone from 'core/assets/svg/phone.svg';
import { openFrontChatPopup } from 'core/components/front-chat';
import { brandConstants, isBranchEnv, appConfig } from 'brand-config';
import useStyles from './agency-support-banner.styles';

function AgencySupportBannerExtended({ content }) {
  const classes = useStyles();

  return (
    <>
      <div className={classes.separator} />
      <Grid container className={classes.container}>
        <Grid className={classes.leftContainer}>
          <Grid item className={classes.icon}>
            <img src={agencySupport} alt="support icon" />
          </Grid>
          <Grid item className={classes.content}>
            <h3 className={classes.heading}>Agency Support</h3>
            <div className={classes.text}>{content}</div>
          </Grid>
        </Grid>
        <Grid item>
          <div>
            {(isBranchEnv || appConfig.helpWidget?.showChat) && (
              <div className={classes.contact}>
                <IconButton className={classes.button} type="button" onClick={openFrontChatPopup}>
                  <img src={chatBubble} alt="contact icon" />
                </IconButton>
                <span className={classes.contactText}>Chat with us</span>
              </div>
            )}
            {brandConstants.AGENCY_SUPPORT_PHONE && (
              <div className={classes.contact}>
                <IconButton
                  className={classes.button}
                  type="button"
                  href={`tel:+1${brandConstants.AGENCY_SUPPORT_PHONE.replace(/\D/g, '')}`}
                >
                  <img src={phone} alt="phone icon" />
                </IconButton>
                <span className={classes.contactText}>Call {brandConstants.AGENCY_SUPPORT_PHONE}</span>
              </div>
            )}
          </div>
        </Grid>
      </Grid>
    </>
  );
}
AgencySupportBannerExtended.propTypes = {
  content: PropTypes.string
};

export default AgencySupportBannerExtended;
